import styled from 'styled-components/macro'
import { motion } from 'framer-motion'

import { styleReset } from 'styles/misc'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'
import { Container } from 'components/container'

export const ObservedPoint = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 1rem;
  height: 5rem;
`

export const StyledNav = styled.nav`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding-block: 2rem 0;
  z-index: 100;

  > ${Container} {
    display: flex;
    align-items: center;
  }
`

export const Logo = styled.img`
  height: 2rem;
  width: auto;
  display: block;
  overflow: hidden;

  ${mq.medium} {
    height: 2.5rem;
  }
`

export const LogoContainer = styled(motion.a)`
  display: block;
  width: max-content;
  color: inherit;
  overflow: hidden;
  margin-inline-end: auto;

  &:hover,
  &:focus {
    color: inherit;
  }
`

export const MenuContainer = styled.div`
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  right: var(--container-spacing);
  width: 1.9rem;
  height: var(--header-height);
  box-sizing: content-box;
  flex-shrink: 0;
  transition: 0.4s opacity 0.55s;
  z-index: 600;

  ${mq.large} {
    width: auto;
  }
`

export const CloseButton = styled.li`
  margin-top: -0.1em;
  padding: 0.8rem;

  button {
    ${styleReset}
    display: block;
    position: relative;
    cursor: pointer;
    width: 1.6rem;
    height: 1.6rem;

    &::before,
    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      border-top: 2px solid white;
      transform: rotateZ(45deg);
    }

    &::after {
      transform: rotateZ(-45deg);
    }
  }

  ${mq.smallOnly} {
    button::before,
    button::after {
      border-top-color: ${theme.colors.accent.primary};
    }
  }
`

export const Menu = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  font-weight: 700;

  ${mq.ltLarge} {
    padding: 3rem var(--container-spacing) 0;
  }

  ${mq.large} {
    margin-right: auto;
  }

  li {
    display: inline;
    padding: 0 1em;

    ${mq.ltLarge} {
      display: block;
      padding: 0.8em 0;

      &:not(:first-child) {
        border-top: 1px solid #ccc;
      }
    }

    ${mq.large} {
      padding: 0 1.6em;
      text-align: center;
    }
  }

  a {
    text-decoration: none;
  }
`

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  height: 3.8rem;

  ${mq.ltLarge} {
    display: block;
    padding-block-end: 3rem;
    height: auto;
    flex-shrink: 0;
  }

  a {
    transition: color 0.2s;
  }

  a:hover,
  a:focus-visible {
    color: ${theme.colors.text}99;
  }
`

export const Backdrop = styled(motion.div)`
  position: fixed;
  inset: 0;
  top: 6rem;
  opacity: 0.5;
  background: ${theme.colors.accent.primary}
    radial-gradient(
      circle at center,
      ${theme.colors.accent.primaryLight},
      ${theme.colors.accent.primary}
    );
`

export const MobileContent = styled(motion.div)`
  position: fixed;
  display: flex;
  flex-direction: column;
  top: 6rem;
  left: 0;
  width: 100%;
  overflow: hidden;
  background-color: white;
  z-index: 100;

  ${mq.large} {
    display: contents;
  }
`

export const MobileToggle = styled.button`
  ${styleReset}

  ${mq.large} {
    display: none;
  }

  &::before {
    content: '';
    display: block;
    width: 3.5rem;
    height: 2rem;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 35 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='0.69873' width='34.3013' height='2' fill='%2314130F'/%3E%3Crect x='0.69873' y='9' width='34.3013' height='2' fill='%2314130F'/%3E%3Crect x='0.69873' y='18' width='34.3013' height='2' fill='%2314130F'/%3E%3C/svg%3E%0A");
  }
`
